import React, { useContext, useEffect, useState } from 'react';
import LegalPage from '../components/LegalPage/LegalPage';
import { StoreContext } from '../context/Store';
import PriceTag from '../components/PriceTag';
import { jsx as ___EmotionJSX } from "@emotion/react";
const VersandUndZahlungPage = () => {
  const {
    0: shippingMethods,
    1: setShippingMethods
  } = useState(null);
  const {
    0: paymentMethods,
    1: setPaymentMethods
  } = useState(null);
  const {
    settings
  } = useContext(StoreContext);
  const {
    data,
    loading
  } = settings;
  const buildMethods = async function (array, id, excludeId) {
    if (excludeId === void 0) {
      excludeId = 0;
    }
    const newArray = [];
    await array.forEach((method, index) => {
      method = method[id];
      if (method.id !== excludeId) {
        newArray.push(method.display_name);
        if (array.length > index + 1) {
          if (array.length === index + 2) {
            newArray.push('oder');
          } else {
            newArray.push(',');
          }
        }
      }
    });
    return newArray.join(' ');
  };
  const setMethods = async () => {
    const shipping = await buildMethods(data.shipping_methods, 'shipping_id');
    const payment = await buildMethods(data.payment_methods, 'payment_id');
    setShippingMethods(shipping);
    setPaymentMethods(payment);
  };
  useEffect(() => {
    if (data) {
      setMethods();
    }
    //eslint-disable-next-line
  }, [data]);
  return ___EmotionJSX(LegalPage, {
    type: "versand-und-zahlung"
  }, loading && ___EmotionJSX("p", null, "Laden"), data && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("p", null, "Die auf den Produktseiten genannten Preise enthalten die gesetzliche Mehrwertsteuer und sonstige Preisbestandteile."), ___EmotionJSX("p", null, "Lieferungen sind nur an Lieferadressen in ", data.shipping_countries.map(_ref => {
    let {
      country_id
    } = _ref;
    return country_id.display_name;
  }), " m\xF6glich. Die Lieferung erfolgt mit ", shippingMethods ? shippingMethods : null, "."), ___EmotionJSX("p", null, "Der Versand innerhalb Deutschlands kostet pauschal ", ___EmotionJSX(PriceTag, {
    priceNetto: data.shipping_cost,
    showMwst: false
  }), "."), ___EmotionJSX("p", null, "Sie k\xF6nnen wahlweise per ", paymentMethods ? paymentMethods : null, " bezahlen.")));
};
export default VersandUndZahlungPage;